import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api.js';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userId, setUserId] = useState(null);
    const [nivelAcesso, setNivelAcesso] = useState(null);
    const [authReady, setAuthReady] = useState(false);

    const verificarToken = async () => {
        try {
            const response = await api.get('/api/verificar-token', { withCredentials: true });
            if (response.data.success) {
                setUserId(response.data.user.id);
                setNivelAcesso(response.data.user.nivel_acesso);
            }
        } catch (error) {
            setUserId(null);
            setNivelAcesso(null);
        } finally {
            setAuthReady(true);
        }
    };

    useEffect(() => {
        verificarToken();
    }, []);

    return (
        <AuthContext.Provider value={{ userId, setUserId, nivelAcesso, setNivelAcesso, authReady }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
